<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>
    <span translate>CREATE_NEW_MANDATE</span>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="crossClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="form" [formGroup]="sepaMandateForm">
    <form *ngIf="sepaMandateForm" [formGroup]="sepaMandateForm">

      <div class="form-row">
        <div class="col-12 mb-3">
          <lib-gung-text-input
            gungTranslate="MANDATE_ID"
            formControlName="mandateId"
            placeholder="{{ 'MANDATE_ID' | translate }}"
            ngbAutofocus
          ></lib-gung-text-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12 mb-3">
          <lib-gung-text-input
            gungTranslate="CUSTOMER_ID"
            formControlName="customerErpId"
            placeholder="{{ 'CUSTOMER_ID' | translate }}"
            ngbAutofocus
          ></lib-gung-text-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <div class="form-group">
            <lib-gung-date-picker
              [currentselectedDate]="sepaMandateForm.get('mandateSignatureDate').value"
              (selectedDate)="sepaMandateForm.get('mandateSignatureDate').setValue($event)"
              label="SIGNATURE_DATE"
            >
            </lib-gung-date-picker>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12 mb-3">
          <lib-gung-text-input
            gungTranslate="IBAN"
            formControlName="debtorIban"
            placeholder="{{ 'IBAN' | translate }}"
            ngbAutofocus
          ></lib-gung-text-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12 mb-3">
          <lib-gung-text-input
            gungTranslate="BIC"
            formControlName="debtorBic"
            placeholder="{{ 'BIC' | translate }}"
            ngbAutofocus
          ></lib-gung-text-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <div class="form-group">
            <label for="file" class="control-label" translate>SIGNED_MANDATE</label>
            <input
              class="form-control"
              type="file"
              id="file"
              (change)="onFileSelected($event)"
            />
          </div>
        </div>
      </div>
    </form>
</div>

<div class="modal-footer">
  <gung-button
    classes="btn btn-primary ml-auto"
    label="{{ 'CREATE_NEW_MANDATE' | translate }}"
    [onClick]="submitForm.bind(this)"
  />
</div>
